import { post } from 'api/_defaults/fetch';

export const startAgent = async ({ agent, files, config, body }) => {
    try {
        // Crea FormData per inviare i file
        const formData = new FormData();

        // Aggiungi ogni file al FormData
        files.forEach((file) => {
            formData.append('files', file);
        });

        if (body) {
            Object.keys(body).filter((key) => body[key] !== undefined).forEach((key) => {
                formData.append(key, body[key]);
            });
        }

        // NOTE: routed through the images-to-ddt endpoint (identical generic
        // image->JSON controller, already deployed on dev) so the agent works
        // without waiting for the images-to-data backend redeploy.
        const data = await post(`/agents/images-to-ddt/${agent._id}`, formData, { config });
        return data;
    } catch (error) {
        console.log('startAgent error:', error);
        throw error;
    }
}
